import React, { useState, useEffect, useRef } from 'react';

const COCINA2 = 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/wu6mwkko_E2E9377F-BB33-47FF-8469-1AFEADEAC76F.jpeg';
const COCINA1 = 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/jwsb3fj7_3CC9A703-5FAE-4776-BDB8-A886C7537DCF.jpeg';

const KITCHEN_SHADOW = 'drop-shadow(0 0 60px rgba(0,0,0,0.15))';

const LifestyleSection = () => {
  const containerRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let rafId;
    const animate = () => {
      if (containerRef.current) {
        const containerTop = containerRef.current.getBoundingClientRect().top + window.scrollY;
        const containerHeight = containerRef.current.offsetHeight;
        const windowHeight = window.innerHeight;
        const prog = Math.max(0, Math.min(1,
          (window.scrollY - containerTop) / (containerHeight - windowHeight)
        ));
        setProgress(prog);
      }
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  // Interpolated values
  const w = 38 + 62 * progress; // vw
  const h = 44 + 56 * progress; // vh
  const br = progress < 0.9 ? 16 : Math.max(0, 16 * (1 - (progress - 0.9) / 0.1));
  const offset = 2 * (1 - progress); // vw/vh offset
  const textOpacity = Math.max(0, (progress - 0.85) / 0.15);
  const overlayOpacity = textOpacity * 0.25;

  return (
    <section
      ref={containerRef}
      data-testid="lifestyle-section"
      style={{ height: '300vh', position: 'relative', background: '#F5F5F7' }}
    >
      <div style={{
        position: 'sticky', top: 0,
        width: '100%', height: '100vh',
        overflow: 'hidden',
        background: '#F5F5F7',
      }}>
        {/* cocina-2 — top-left expanding */}
        <img
          src={COCINA2}
          alt="ETERNA — Espacio de vida"
          style={{
            position: 'absolute',
            left: `${offset}vw`,
            top: `${offset}vh`,
            width: `${w}vw`,
            height: `${h}vh`,
            objectFit: 'cover',
            filter: KITCHEN_SHADOW,
            willChange: 'width, height, left, top',
            zIndex: 1,
          }}
        />

        {/* cocina-1 — bottom-right expanding */}
        <img
          src={COCINA1}
          alt="ETERNA — Autonomía"
          style={{
            position: 'absolute',
            right: `${offset}vw`,
            bottom: `${offset}vh`,
            width: `${w}vw`,
            height: `${h}vh`,
            objectFit: 'cover',
            filter: KITCHEN_SHADOW,
            willChange: 'width, height, right, bottom',
            zIndex: 2,
          }}
        />

        {/* Overlay + text on cocina-1 at progress > 0.85 */}
        <div style={{
          position: 'absolute',
          right: `${offset}vw`,
          bottom: `${offset}vh`,
          width: `${w}vw`,
          height: `${h}vh`,
          zIndex: 3,
          background: `rgba(10,10,10,${overlayOpacity})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          willChange: 'width, height, right, bottom',
        }}>
          <p style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(28px, 4.5vw, 64px)',
            color: '#FFFFFF',
            textAlign: 'center',
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
            maxWidth: '800px',
            padding: '0 24px',
            opacity: textOpacity,
          }}>
            Más que hidratación. Autonomía.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LifestyleSection;
